import BookmarkedAttrs from '@/interface/BookmarkedAttrs';

const state = () => ({
  isLoading: false,
  job: null,
});

// mutations
const mutations = {
  setLoading(currentState, newValue: boolean) {
    currentState.isLoading = newValue;
  },
  setJob(currentState, newValue: object) {
    currentState.job = newValue;
  },
  setItemBookmarkStatus(currentState, item: BookmarkedAttrs) {
    if (item.id === currentState.job?.id) {
      currentState.job = {
        ...currentState.job,
        isBookmarked: item.value,
      };
    }
  },

};
// mutations end

// actions
const actions = {
  fetch(
    { commit },
    { id, campaignId, isJobSlugPage, locale }: { id: string; campaignId: string; isJobSlugPage: boolean; locale: string },
  ) {
    commit('setLoading', true);
    commit('setJob', null);

    const routeParams = { jobId: id };
    if (locale) {
      routeParams['locale'] = locale;
    }
    const extraParams = isJobSlugPage ? { srp: '1' } : {};
    if (campaignId) {
      extraParams['campaignId'] = campaignId;
    }

    return this.$api
      .get(this.getters.getApiLink('job.details_v2', routeParams, extraParams))
      .then(({ data }) => {
        // data = {"status":"OK","message":"","payload":{"type":"json","content":{"id":"eacd6ab9d243bde784155d6c5d76d0e69","title":"Junior Business Development Manager - Digital Media (M\/F\/D)","company":"Only for registered members","currency":"EUR","salary":"EUR 60,000 - 80,000","salaryMax":80000,"salaryMin":60000,"location":"Homburg","countryCode":"DEU","countryShortCode":"DE","releasedSince":"30+ days ago","releasedSinceDays":233,"source":"headhunter","isAccessible":false,"canUserApply":false,"description":"","sourceUrl":"https:\/\/www.creativepersonnel.co.uk\/job\/100037534985142\/junior-business-development-manager-digital-media-m-slash-f-slash-d\/","isBookmarked":false,"hostname":"www.creativepersonnel.co.uk","screenshots":[],"visibleForRobots":false,"isDeactivated":false,"sendNotFoundStatusCode":false,"postedAt":"2022-09-05","validThrough":"2022-11-04"}}}
        const job = data?.payload?.content || null;
        if (!job) {
          return null;
        }

        if (job.freeJobs) {
          commit('jobSearch/setFreeJobs', job.freeJobs, { root: true});

          if (job.freeJobs.type === 'topJobs' && job.freeJobs.perks) {
            commit('jobSearch/addFreeJobsItem', job, { root: true});
          }
          if (job.freeJobs.type === 'contingent' && job.freeJobs.isFreeJobs) {
            commit('jobSearch/addFreeJobsItem', job, { root: true});
          }
        }

        commit('setJob', job);
        return job;
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  setItemBookmarkStatus({ commit }, newValue: boolean) {
    commit('setItemBookmarkStatus', newValue);
    return newValue;
  },

  trackLandingpageView(_, payload) {
    payload.type = 'lp:pageview';

    return this.$api.jsonPost(this.getters.getApiLink('tracking.conversions'), payload);
  }
};
// actions end

const getters = {
  job: (s) => s.job,
  isLoading: (s) => s.isLoading,
};

export default {
  namespaced: true,
  mutations,
  state,
  actions,
  getters,
};
